import { Injectable } from '@angular/core';

import { ConfigParserService } from '../shared/services/config-parser.service';

export interface AutoSuggestConfig {
    sharePointContextInitPath: string;
}

@Injectable({
    providedIn: 'root'
})
export class AutoSuggestConfigService {
    public readonly config: AutoSuggestConfig;

    constructor(
        configParserService: ConfigParserService
    ) {
        this.config = configParserService.parse<AutoSuggestConfig>('autoSuggestConfig') || {
            sharePointContextInitPath: null
        };
    }
}
